import {
  FormControlLabel,
  Grid2,
  Radio,
  RadioGroup,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import { formatDollarAmount } from '../../../utils/global/helper';

interface TerminalProductProps {
  selectedProduct: string | null;
  setSelectedProduct: (product: string | null) => void;
  image: string;
  title: string;
  description: string;
  price: number;
  monthlyPrice: number;
  months: number;
  priceId: string;
  monthlyPriceId: string;
}

function TerminalProduct({
  selectedProduct,
  setSelectedProduct,
  image,
  title,
  description,
  price,
  monthlyPrice,
  months,
  priceId,
  monthlyPriceId,
}: TerminalProductProps) {
  const theme = useTheme();

  return (
    <Grid2
      position="relative"
      p={3}
      bgcolor={theme.palette.lightGrey.main}
      borderRadius="10px"
      size={{
        xs: 12,
        sm: 6,
      }}
      display="flex"
      alignItems="stretch"
      overflow="hidden">
      <Grid2
        container
        columns={12}
        width="100%"
        height={{
          xs: '100%',
          md: 'auto',
        }}>
        <Grid2
          size={{
            xs: 12,
            md: 4,
          }}
          maxWidth="200px"
          mx="auto"
          alignItems="center"
          justifyContent="center"
          overflow="hidden">
          <img
            src={image}
            alt="Terminal"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              borderRadius: '10px',
              maxHeight: '300px',
            }}
          />
        </Grid2>
        <Grid2
          size={{
            xs: 12,
            md: 8,
          }}>
          <Stack gap={2} justifyContent="space-around" height="100%">
            <Stack gap={1}>
              <Typography variant="h3">{title}</Typography>
              <Typography variant="body2">{description}</Typography>
            </Stack>
            <RadioGroup
              sx={{
                gap: 1,
              }}
              aria-labelledby="radio-terminal-type"
              name="terminal-type"
              value={selectedProduct}
              onChange={e => setSelectedProduct(e.target.value)}>
              <FormControlLabel
                sx={{
                  bgcolor: '#ffffff',
                  borderRadius: '10px',
                  p: 1.5,
                  m: 0,
                  '&:hover': {
                    filter: 'brightness(0.9)',
                  },
                }}
                value={priceId}
                label={
                  <Typography variant="body2" component="p" ml={1}>
                    {formatDollarAmount(price, true)}
                  </Typography>
                }
                control={
                  <Radio
                    sx={{
                      p: 0,
                    }}
                  />
                }
              />
              <FormControlLabel
                sx={{
                  bgcolor: '#ffffff',
                  borderRadius: '10px',
                  p: 1.5,
                  m: 0,
                  '&:hover': {
                    filter: 'brightness(0.9)',
                  },
                }}
                value={monthlyPriceId}
                label={
                  <Typography variant="body2" component="p" ml={1}>
                    {formatDollarAmount(monthlyPrice, true)}/mo for {months}{' '}
                    months
                  </Typography>
                }
                control={<Radio sx={{ p: 0 }} />}
              />
            </RadioGroup>
          </Stack>
        </Grid2>
      </Grid2>
    </Grid2>
  );
}

export default TerminalProduct;
